export const copyToClipboard = async text => {
  const fallbackCopy = () => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-9999px';
    textArea.style.top = '0';
    textArea.setAttribute('readonly', '');
    document.body.appendChild(textArea);
    textArea.select();
    textArea.setSelectionRange(0, text.length);
    const success = document.execCommand('copy');
    document.body.removeChild(textArea);
    return success;
  };

  if (!navigator.clipboard || !navigator.clipboard.writeText) {
    return fallbackCopy();
  }

  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    return fallbackCopy();
  }
};

export default copyToClipboard;
